// @flow
import React, { Component, type Node } from 'react';
import ScrollToTop from 'components/common/ScrollToTop';
import './ProductsTagsTemplate.scss';

type Props = {
  children: Node,
};

class ProductsTagsTemplate extends Component<Props> {
  render() {
    const { children } = this.props;
    return <div className="ProductsTagsTemplate">{children}</div>;
  }
}

export default ProductsTagsTemplate;



// WEBPACK FOOTER //
// ./src/components/tags/ProductsTagsTemplate/ProductsTagsTemplate.js